"use client";
import Image from "next/image";
import { useState, useCallback, useEffect } from "react";
import { Input, Space } from 'antd'
import { Login } from "@/app/components/user/login";
import userInfoStore from "@/store/userInfoStore";
import Link from "next/link";
import { usePathname } from 'next/navigation'
import { unreadCount } from "@/service/common/index";
import useMobileDetect from "@/hooks/useMobileDetect";
import { useRouter } from 'next/navigation'

import btn_setting from "@/app/assets/mine/btn_setting@2x.png";
import title_logo_png from "@/app/assets/common/title_logo.png";
import tab_message_png from "@/app/assets/common/tabbar/tab_message.png";
import tab_me_png from "@/app/assets/common/tabbar/tab_me.png";
import userDefault from "@/app/assets/mine/user_default@2x.png";

import "./index.css";

type headerProps = {
  top?: number;

};

const { Search } = Input;
export default function Index({
  top = 48
}: headerProps) {

  const isMobile = useMobileDetect();
  const { userInfo } = userInfoStore();
  const pathname = usePathname()
  const router = useRouter()

  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [curIdx, setCurIdx] = useState(0);

  useEffect(() => {
    if (!isMobile) {
      unreadCount<{
        unreadCount: number
        defaultChatLink: string
      }>().then((res) => {
        if (res.code === 0) {
          const data = res.data
          setCount(data.unreadCount)
          globalThis?.localStorage?.setItem("defaultChatLink", data.defaultChatLink)
          // @ts-ignore
          globalThis?.getDefaultChatLinkCallback && globalThis.getDefaultChatLinkCallback(data.defaultChatLink)
        }
      });

      if (pathname === '/mine') {
        setCurIdx(1)
      } else if (pathname === '/message') {
        setCurIdx(2)
      } else {
        setCurIdx(0)
      }
    }
  }, [isMobile])

  const openLogin = useCallback(() => {
    setOpen(true)
  }, [])

  const SignInBtnComponent = () => {
    return <div style={{ maxWidth: 'var(--max-width)', margin: '0px auto' }}>
      <div
        className={`flex py-9 px-10 items-center justify-between w-full fixed top-${top} z-100 mx-auto display-none bg-bravve-bg-201`}
        style={{ zIndex: 999, maxWidth: "var(--max-width)" }}
      >
        <div className="flex items-center ">
          <Link href="/" className="flex items-center ">
            <Image src={title_logo_png} alt="logo" className="w-40 h-40" width={40} height={40} />
            <div className="font-bold text-bravve-100 ml-10 text-20">AskPaul</div>
          </Link>
          <Search placeholder="Search Prediction Market" 
            style={{ width: 688 }} 
            className="ml-40 searchBnt" 
            onSearch={(value: string) => {
              router.push('/search?keywords=' + value)
            }}
          />
        </div>
        <div className="flex items-center">
          {
            userInfo?.userName || userInfo?.email ?
              <Link
                className={(curIdx === 1 ? " border-b-2 border-bravve-100 " : "") + " flex items-center pb-4 "}
                href="/mine">
                <Image src={userInfo.userIcon && userInfo.userId ? userInfo.userIcon : userDefault}
                  alt="userDefaultIcon" width={28} height={28} className="w-28 h-28 mr-10 rounded-half" />
                <span className="text-white">{userInfo?.userName || userInfo?.email || "Log In"}</span>
              </Link>
              :
              <div
                className={(curIdx === 1 ? " border-b-2 border-bravve-100 " : "") + " flex items-center pb-4 "}
                onClick={() => {
                  document.getElementById('signInButton')?.click()
                }}
              >
                <Image src={tab_me_png} alt="me" className="w-28 h-28 mr-10" width={28} height={28} />
                <span className="text-white">{"Log In"}</span>
              </div>
          }
          <Link
            className={(curIdx === 2 ? " border-b-2 border-bravve-100 " : "") + " flex items-center relative ml-50 pb-4"}
            href="/message">
            <Image src={tab_message_png} alt="message" className="w-28 h-28" width={28} height={28} />
            {
              count > 0 && (
                <div className="absolute -top-10 -right-10 w-18 h-18 rounded-full bg-[#FF0000] text-white font-bold text-xs text-center">{count}</div>
              )
            }
          </Link>
          {
            userInfo?.userName || userInfo?.email ? <Link
              href="/website-settings"
              className={"flex items-center pb-4"}
            >
              <Image src={btn_setting} alt="settings" width={38} height={38} className="w-38 h-38 ml-20" />
            </Link> : false
          }
        </div>
      </div>
      <div className="h-62 display-none"></div>
      <div id="signInButton" className="h-1 w-1 bg-transparent fixed" onClick={openLogin}></div>
    </div>
  }

  return (
    <>
      <SignInBtnComponent />
      <Login open={open} onClose={() => setOpen(false)} />
    </>
  );
}
